import type { FeatureKey } from './registry';
import { useFeatureFlagsContext } from './FeatureFlagsProvider';

export function useFeature(key: FeatureKey): { enabled: boolean; loading: boolean } {
  const { isEnabled, loading } = useFeatureFlagsContext();
  return { enabled: isEnabled(key), loading };
}
